export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_03.2240be85.jpg";